export const RECIPIENT_LIST = 'recipientList';
export const RECIPIENTS_SELECTED_LIST = 'recipientsSelectedList';

export const TYPE = 'type';
export const TYPE_EMAIL = 'typeEmail';
export const TYPE_NOTIFICATION = 'typeNotification';

export const SUBJECT = 'subject';
export const FROM_ENTITY = 'fromEntity';
export const FROM_ENGAGEMENT = 'fromEngagement';
export const FROM_ENTITY_NOTIFICATION = 'fromEntityNotification';
export const NOTIFICATION_MESSAGE = 'notificationMessage';
export const LINK_LABEL = 'linkLabel';
export const LINK = 'link';

export const getTypeEmail = (name) => ({id: TYPE_EMAIL, name});
export const getTypeNotification = (name) => ({id: TYPE_NOTIFICATION, name});
